export const environment = {
  projectName: 'EMiRLD',
  defaultTheme: 'EMiRLD',
  production: false,
  name: 'dev',
  version: '1.4.0',
  region: 'us-gov-west-1',
  url: 'https://emirld-dev.cristlgov.com/',
  endpoint: 'https://emirld-be-dev.cristlgov.com',
  refreshEndpoint: 'https://dev-be.cristlgov.com/auth/refreshToken',

  sandboxEnabled: false,
  uamUrl: 'https://dev.cristlgov.com/',
  cookieInfo: {
    domain: '.cristlgov.com',
  }
};
